import React from 'react';
import PropTypes from 'prop-types';
import { printAddressNicely } from '../../selectors/addressSelector';
import { combineNames } from '../../selectors/converterSelector';

function ListingItem(props) {
    const { item } = props;

    if (!item) {
        return '';
    }

    const {
        BusinessName,
        FirstName,
        Surname,
        Phone,
        Email,
        BusinessAddress,
    } = item;

    return (
        <div className='store-list__item'>
            <span className='store-list__heading'>
                {BusinessName ||
                    combineNames([FirstName, Surname]) ||
                    'Nameless User'}
            </span>
            <div className='store-list__content text-box'>
                <p>
                    <span
                        dangerouslySetInnerHTML={{
                            __html:
                                printAddressNicely(BusinessAddress) ||
                                'Addess has not been set',
                        }}
                    />
                    <br />
                    {Phone != '' && Phone != null && (
                        <React.Fragment>
                            Phone:{' '}
                            <a href={`tel: ${Phone}`}>{Phone || 'n/a'}</a>
                            <br />
                        </React.Fragment>
                    )}
                    {/*{Email != '' && Email != null && <React.Fragment>Email: <a href={`mailto: ${Email}`}>{Email || 'n/a'}</a><br/></React.Fragment>}*/}
                </p>
            </div>
        </div>
    );
}

// default props
ListingItem.defaultProps = {
    item: {},
};
// validate props
ListingItem.propTypes = {
    item: PropTypes.object.isRequired,
};

export default ListingItem;
